import { TenantCustomization } from "./TenantCustomization.ts";

const BmwRs: TenantCustomization = {
    getButtonElement: () => document.getElementsByClassName("chatbot-button")?.[0] as HTMLDivElement,
};
export default BmwRs;
